import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import { planFragment } from '@zapier/upsells/src/fragments';

import {
  ApolloInjection,
  BillingInterval,
  NextPlanQuery,
  PlanType,
} from '@zapier/upsells/src/types';

export const nextPlanQuery = gql`
  query upsells_nextPlanQuery(
    $accountId: Int!
    $interval: BillingInterval
    $type: String
  ) {
    nextPlan: nextPlanV2(
      accountId: $accountId
      interval: $interval
      type: $type
    ) {
      ...upsells_planFragment
    }
  }
  ${planFragment}
`;

type Props = {
  accountId: number | undefined;
  interval?: BillingInterval;
  skip?: boolean;
  type?: PlanType;
} & ApolloInjection;

export const useNextPlan = ({
  useQuery,
  accountId,
  interval,
  skip = false,
  type,
}: Props) => {
  const _useQuery = useQuery || defaultUseQuery;

  const { loading: isLoading, data, error } = _useQuery<NextPlanQuery>(
    nextPlanQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId,
        interval,
        type,
      },
    }
  );

  return {
    error: error?.message,
    isLoading,
    nextPlan: data?.nextPlan,
  };
};
